import MonitoringSubFilters from './MonitoringSubFilters';
import MonitoringCommonFilters from './MonitoringCommonFilters';
import { useSideNavActive } from '../LayoutWrapper/SideNavLayoutContext';

export const MonitoringFilters = () => {
  const sideNavActive = useSideNavActive();

  return (
    <div className="flex flex-column gap-md">
      <div className="grid nc_filters align-items-center">
        {!sideNavActive && (
          <div className="field col-12 lg:col-2">
            <h4>Report Settings:</h4>
          </div>
        )}
        <MonitoringCommonFilters roadmapRequired={false} />
      </div>
      {!sideNavActive && <MonitoringSubFilters />}
    </div>
  );
};
